import React from 'react';
import PropTypes from 'prop-types';
import {RestJsonReports, API_REPORT} from '../restClient';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import styled from 'styled-components';
import moment from 'moment';

import getDefaultValues from '../components/form/getDefaultValues';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import DatePicker from 'material-ui/DatePicker';
import { reduxForm, Field } from 'redux-form';
import ContentSave from 'material-ui/svg-icons/file/cloud-download';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';

const noop = () => {};

class ReportForm extends React.Component{
  constructor(props){
    super(props);
    const minDate = new Date();
    const maxDate = new Date();
    this.state = {
      isGenerate: false,
      valueReport: '',
      minDate: minDate,
      maxDate: maxDate,
      currentDate: new Date()
    }

  }
  handleChangeMinDate = (event, date) => {
    this.setState({
      minDate: date,
    });
  };

  handleChangeMaxDate = (event, date) => {
    this.setState({
      maxDate: date,
    });
  };
  loadReport = (params) =>{
    RestJsonReports(params).then((response) => {
      if (response.status >= 400) {
        throw new Error("Bad response from server");
      }
      return response.json();
    })
    .then((data) => {
      this.downloadfile(data.url);
      this.setState({isGenerate: false});
    }).catch((e) => {
      this.setState({isGenerate: false});
      console.error(e);
    });
  }

  handleGenerate = (event) => {
    if(this.state.valueReport !== ''){
      const startDate = moment(this.state.minDate).format('YYYY-MM-DD');
      const endDate = moment(this.state.maxDate).format('YYYY-MM-DD');
      this.setState({isGenerate:true});
      const params1 = 'type='+ this.state.valueReport+'&startDate='+startDate+'&endDate='+endDate;
      this.loadReport(params1);
    }
  }
  downloadfile = (url) => {
    let tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    // "http://api.staging.ola.id"
    tempLink.href = API_REPORT+url;
    let resfile = url.lastIndexOf('/')+1;
    let newfileName = url.substring(resfile,url.length);
    tempLink.setAttribute('download', newfileName);
    // Safari thinks _blank anchor are pop ups. We only want to set _blank
    // target if the browser does not support the HTML5 download attribute.
    // This allows you to download files in desktop safari if pop up blocking
    // is enabled.
    if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank');
    }
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  }
  handleChoice = (event,value, input) => {
    this.setState({valueReport:value});
    input.onChange(value);
  }
  renderRadioGroup = ({ input, ...rest }) => (
    <RadioButtonGroup {...input} {...rest}
      valueSelected={input.value}
      style={{display: 'flex', flexDirection: 'row',flex: 1, flexWrap: 'wrap', justifyContent: 'center', alignItems:'center'}}
      onChange={(event, value) => this.handleChoice(event,value,input)}/>
  )
  render() {
     const { handleSubmit, submitOnEnter } = this.props;
    return(
      <div>
        <form onSubmit={ submitOnEnter ? handleSubmit : noop } className="simple-form">
          <DivContainer>
            <div>
              <DatePicker
                onChange={this.handleChangeMinDate}
                floatingLabelText="Start Date"
                defaultDate={this.state.minDate}
                maxDate={this.state.currentDate}
              />
              <DatePicker
                onChange={this.handleChangeMaxDate}
                floatingLabelText="End Date"
                defaultDate={this.state.maxDate}
                minDate={this.state.minDate}
                maxDate={this.state.currentDate}
                
              />
            </div>  
            <DivTitle>Type</DivTitle>  
            <Field name="report" component={this.renderRadioGroup}>
              <RadioButton value="all" label="All" style={{display: 'flex',}}/>
              <RadioButton value="paid" label="Paid" style={{display: 'flex', }}/>
              <RadioButton value="delivered" label="Delivered" style={{display: 'flex', }}/>
            </Field>
            <div style={{display: 'flex', flex: 1, justifyContent: 'center', paddingTop: '0.5em'}} >
              <RaisedButton
                label="Generate"
                icon={this.state.isGenerate  ? <CircularProgress size={25} thickness={2} /> : <ContentSave />}
                onClick={(event)=>this.handleGenerate(event)}
                primary={true}
                style={{
                  margin: '10px 24px',
                  position: 'relative',
                }}/>
            </div>
          </DivContainer>
        </form>
      </div>  

    );
  }
}

const DivContainer = styled.div`
  padding: 3em 1em 6em 1em;
  @media only screen and (min-width: 768px) {
    padding: 0 1em 1em 1em;
  }
`;
const DivTitle = styled.div`
  padding: 16px 0;
`;

ReportForm.propTypes = {
    children: PropTypes.node,
    defaultValue: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func,
    ]),
    handleSubmit: PropTypes.func,
    invalid: PropTypes.bool,
    record: PropTypes.object,
    resource: PropTypes.string,
    basePath: PropTypes.string,
    validate: PropTypes.func,
    submitOnEnter: PropTypes.bool,
};

ReportForm.defaultProps = {
    submitOnEnter: false,
};

const enhance = compose(
    connect((state, props) => {
      return ({
        initialValues: getDefaultValues(state, props),
      })
    }),
    reduxForm({
        form: 'record-form',
        enableReinitialize: true,
    }),
);

export default enhance(ReportForm);



// WEBPACK FOOTER //
// ./src/reports/ReportForm.js